import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { createSelector } from 'reselect';
import _get from 'lodash/get';
import { contactSelectors, featureSelectors, accountSelectors, directoryActions } from '@lifesize/nucleus';
import actions, { loadInitialUsers } from 'actions/Contact';
import { openFullScreenModal } from 'actions/FullScreenModal';
import { endRouteLoading } from 'actions/SideNav';
import Contacts from 'components/Contacts/Contacts';
import { SCHEDULE_MODAL } from 'constants/ScheduleModal';
import { CONTACT_MODAL } from 'constants/ContactModal';
import { CONTACTS_FILTER_OPTION_MY_CONTACTS } from 'constants/Contact';
import { routes } from 'constants/Application';
import { selectPreviousPath } from 'selectors/auth';

/*  Object of action creators (can also be function that returns object).
    Keys will be passed as props to presentational components. Here we are
    implementing our wrapper around increment; the component doesn't care   */

function mapDispatchToProps(dispatch, ownProps) {
  return {
    endRouteLoading: () => dispatch(endRouteLoading()),
    fetchNext: () => dispatch(directoryActions.fetchNext(['USER'])),
    handleAudioCall: contact => dispatch(actions.startAudioCall(contact)),
    handleChat: contact => {
      ownProps.history.push(routes.chat);
      dispatch(actions.chatWith(contact));
    },
    handleCreateContact: () => {
      ownProps.history.push(routes.contacts);
      dispatch(actions.createContact());
    },
    handleDelete: contact => dispatch(openFullScreenModal(CONTACT_MODAL, { contact, isDelete: true })),
    handleEdit: contact => dispatch(openFullScreenModal(CONTACT_MODAL, { contact })),
    handleFilterChange: (type, value) => dispatch(actions.contactsFilterChange(type, value)),
    handleSchedule: id => dispatch(openFullScreenModal(SCHEDULE_MODAL, id)),
    handleVideoCall: contact => dispatch(actions.startVideoCall(contact)),
    loadGroupAndOwnContacts: () => dispatch(directoryActions.partialLoad(['PERSONAL', 'GROUP'])),
    loadInitialUsers: () => dispatch(loadInitialUsers())
  };
}

const filterValue = state => _get(state, 'app.contacts.filters.contacts');
const contactsSwitch = createSelector(
  filterValue,
  contactSelectors.usersSelector,
  contactSelectors.myPersonalContacts,
  (filter, all, personal) => {
    switch (filter) {
      case CONTACTS_FILTER_OPTION_MY_CONTACTS:
        return personal;
      default:
        return all;
    }
  }
);

const mapStateToProps = state => {
  const filterVal = filterValue(state);
  const contacts = contactsSwitch(state);

  return {
    contacts: contacts,
    filter: filterVal,
    getSelectedContact: uuid => contactSelectors.getContactByUuidGenerator(state)(uuid),
    isChatEnabled: featureSelectors.isChatEnabled(state) && accountSelectors.getAccountFeatures(state).isChatEnabled,
    loading: _get(state, 'app.contacts.loadingUsers'),
    previousPath: selectPreviousPath(state),
    scrollToSelected: state.app.contacts.scrollToSelected
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Contacts));
